export default __webpack_public_path__ + "static/media/sun.d1588f61.svg";